<template>
  <div class="bg-black min-h-screen flex">
    <div class="loading_overlay" v-if="isLoading.single" />
    <sidebar-movie>
      <browse-and-filter :sliderIDs="{ runtime: 'sidebar-movie2' }" />
    </sidebar-movie>
    <sidebar-base :show="showSidebar" @closeSidebar="toggleSidebar">
      <browse-and-filter :sliderIDs="{ runtime: 'sidebar-base2' }" />
    </sidebar-base>
    <section class="p-4 pt-16 pb-40 text-white flex-1 overflow-x-hidden">
      <div class="block md:hidden mt-3">
        <button-base :background="'yellow'" @click="toggleSidebar"
          >Browse & Filter</button-base
        >
      </div>
      <router-view />
    </section>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import SidebarMovie from "@/components/Sidebar/SidebarMovie.vue";
import SidebarBase from "@/components/Sidebar/SidebarBase.vue";
import BrowseAndFilter from "@/components/Sidebar/BrowseAndFilter.vue";

export default {
  name: "explore-movie",
  components: {
    SidebarMovie,
    SidebarBase,
    BrowseAndFilter
  },
  setup() {
    const store = useStore();
    let initMovieData = {
      page: 1,
      runtime: [1, 600],
      view_set: "grid"
    };
    let showSidebar = ref(false);
    const route = useRoute();
    const router = useRouter();

    let toggleSidebar = () => {
      showSidebar.value = !showSidebar.value;
    };

    let movie_store = localStorage.getItem("movie_store");
    if (movie_store) {
      movie_store = JSON.parse(movie_store);
    }

    if (!movie_store) {
      router.push({
        path: route.path,
        query: {
          ...route.query,
          ...initMovieData
        }
      });

      localStorage.setItem("movie_store", JSON.stringify(initMovieData));
    } else if (route.query.page) {
      movie_store = { ...movie_store, page: parseInt(route.query.page) };
      localStorage.setItem("movie_store", JSON.stringify(movie_store));
      router.push({
        path: route.path,
        query: {
          ...route.query,
          ...movie_store
        }
      });
    } else {
      router.push({
        path: route.path,
        query: {
          ...route.query,
          ...movie_store
        }
      });
    }

    let isLoading = computed(() => store.state["tmdbApi"].isLoading);

    return {
      toggleSidebar,
      showSidebar,
      isLoading
    };
  }
};
</script>
